<template>
  <Loading v-if="!whoWeAre" />
  <div v-else>
    <div class="about-banner-image rounded-b-2xl relative" style="background: url(/static/images/about.jpg)">
      <div class="about-banner-overlay"></div>

      <div class="absolute top-14">
        <div class="about-us-section layout-padding mt-44">
          <div class="aboutus-underla uppercase text-white text-7xl mb-3">{{ content.aboutUs }}</div>
          <div class="about-title text-white">{{ content.whoWeAre }}</div>

        </div>
      </div>
    </div>
    <div>
      <p class="text-safetyBlack text-lg  mt-14 text-white paragraph" style="margin: 40px;">
        {{ whoWeAre[0].description }}
      </p>
    </div>

    <div class="
        approach-section
        grid grid-cols-2
        mt-28
        layout-padding
        mb-32
        gap-20
      ">
      <div class="col-span-2 lg:col-span-1">
        <div class="approach-image" :style="`background: url(${whoWeAre[0].image})`">
          <div class="img-overlay-two"></div>
        </div>
      </div>
      <div class="col-span-2 lg:col-span-1 flex flex-col justify-center lg:mt-0">
        <div class="approach-titl text-6xl text-safetyBlack">{{ content.ourApproach }}</div>
        <div class="approach-content mt-8 paragraph">
          {{ whoWeAre[0].approach }}
        </div>
        <div class="vision-title mt-11 text-6xl text-safetyBlack">{{ content.ourVision }}</div>
        <div class="vision-content mt-4 paragraph">
          {{ whoWeAre[0].vision }}
        </div>
        <div class="mission-title mt-11 text-6xl text-safetyBlack">{{ content.ourMission }}</div>
        <div class="mission-content mt-4 paragraph">
          {{ whoWeAre[0].mission }}
        </div>
      </div>
    </div>
  </div>
  <TheFooter :withContact="true" />
</template>
<script>
export default {
  inject: ["content"],
  methods: {
    async loadData() {
      if (!this.whoWeAre) await this.$store.dispatch("whoWeAre/getWhoWeAre");
    },
  },
  computed: {
    whoWeAre() {
      return this.$store.getters["whoWeAre/whoWeAre"];
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>